// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bfQ4z{padding-inline:8px}.rjp7L{padding-inline:8px;margin-top:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"groupLabel": `bfQ4z`,
	"groupLabelSpaced": `rjp7L`
};
export default ___CSS_LOADER_EXPORT___;
